export default Object.freeze({
	Label: 'Label',
	Envelope: 'Envelope',
	ReturnLabel: 'ReturnLabel',
});
